<mat-toolbar color="primary" style="position: sticky; top: 0; z-index: 999">
  <span style="display: flex; flex-grow: 1">Ngx-Progress-Overlay</span>
</mat-toolbar>

<div class="container">
  <br /><br />

  <div class="align-center">
    A simple donut progress bar with full screen overlay.
  </div>

  <br />

  <div class="align-center">
    <button mat-raised-button color="primary" (click)="test()">
      Start Loader
    </button>
  </div>

  <br /><br />

  <h4>Installation</h4>

  <mat-card>
    <pre class="code">{{ code.installation }}</pre>
  </mat-card>

  <br /><br />

  <h4>Usage</h4>

  <div class="text-secondary">
    Import `NgxProgressOverlayModule` in the root module (`AppModule`) :
  </div>

  <br />

  <mat-card>
    <pre class="code">{{ code.usage.step1 }}</pre>
  </mat-card>

  <br />

  <div class="text-secondary">
    Add `NgxProgressOverlayService` service in your component :
  </div>

  <br />

  <mat-card>
    <pre class="code">{{ code.usage.step2 }}</pre>
  </mat-card>

  <br />

  <div class="text-secondary">
    Finally, use NgxProgressOverlayComponent in your template
  </div>

  <br />

  <mat-card>
    <pre class="code">{{ code.usage.step3 }}</pre>
  </mat-card>

  <br /><br />

  <div class="align-center">
    <a
      matTooltip="Github"
      target="_blank"
      href="https://github.com/monkeyscript/ngx-progress-overlay"
    >
      <button mat-icon-button color="primary">
        <i class="fa fa-github"></i>
      </button>
    </a>
  </div>

  <br /><br />
</div>

<ngx-progress-overlay></ngx-progress-overlay>
